import { imageModel } from "./defaults";

export const recraft41 = imageModel("recraft-4.1", "Recraft 4.1", {
  text: "recraft/v4.1/text-to-image",
});
